<template lang="pug">
  .input--select
    div(:class="inputClasses")
      label(v-if="!hideLabel", :for="selectId", :class="labelClass") {{ label }}
      v-select(
        v-if="!showNativeSelect"
        :ref="selectId"
        :class="selectClasses"
        :options="options"
        :disabled="disabled"
        :clearable="false"
        :value="selectedValue",
        :input-id="selectId"
        :placeholder="defaultOption",
        :searchable="false",
        :select-on-tab="true",
        @input="update",
        @click="update"
        @open="onOpen(true)"
        @close="onOpen"
      )
        template(#open-indicator="{ openIndicatorAttributes }")
          Icon(:name="iconName", size="13px", v-bind="openIndicatorAttributes")
      select(v-else v-model="currentValue" :disabled="disabled" :id="selectId" :class="showNativeSelect ? 'mobile-select' : ''")
        option(v-for="option in options", :value="option.value", :key="option.value") {{ option.label }}
    .input-error-list
      slot(name="errors")
</template>

<script>
  import vSelect from 'vue-select';

  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'SelectInput',
    components: { vSelect, Icon },
    props: {
      options: {
        type: Array,
        default: () => [],
      },
      selected: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      label: {
        type: String,
      },
      hideLabel: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: 'Default',
      },
      iconSize: {
        type: String,
        default: '24px',
      },
      secondary: {
        type: Boolean,
        default: false,
      },
      value: String,
      validator: {
        type: Function,
      },
      theme: {
        type: String,
        default: 'default',
        validator: (theme) => {
          const selectInputThemes = ['default', 'with-icon', 'with-color'];

          return selectInputThemes.includes(theme);
        },
      },
      mobileNativeSelect: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        currentValue: '',
        iconName: 'caret-down',
        selectId: `select${this._uid}`,
        openedSelect: false,
        closeIndicatorAttributes: {
          ref: 'closeIndicator',
          role: 'presentation',
          class: 'vs__close-indicator',
        },
        openIndicatorAttributes: {
          ref: 'openIndicator',
          role: 'presentation',
          class: 'vs__open-indicator',
        },
      };
    },
    computed: {
      defaultOption() {
        return this.placeholder !== '' ? this.placeholder : '';
      },
      selectedValue() {
        return this.options.find((option) => {
          if (!option.value) {
            return option === this.currentValue;
          }

          return option.value === this.currentValue;
        });
      },
      showNativeSelect() {
        return this.$mq === 'mobile' && this.mobileNativeSelect;
      },
      labelClass() {
        return {
          'u-sr-only': this.hideLabel,
        };
      },
      inputClasses() {
        const currentValueIsValid = this.validator !== undefined && this.isValid;
        const currentValueIsInvalid = this.validator !== undefined && !this.isValid;

        return [
          {
            'input--error': this.$slots.errors || currentValueIsInvalid,
            'input--success': currentValueIsValid,
          },
        ];
      },
      isValid() {
        return this.validator ? this.validator(this.currentValue) : null;
      },
      selectClasses() {
        return {
          focused: this.openedSelect,
        };
      },
    },
    watch: {
      value() {
        this.currentValue = this.value;
      },
      currentValue() {
        this.$emit('input', this.currentValue);
      },
    },
    created() {
      let selected = '';

      if (this.selected) {
        selected = { value: this.selected.value || this.selected };
      } else {
        selected = this.options[0].value || this.options[0];
      }

      this.update(selected);
    },
    methods: {
      update(val) {
        this.currentValue = val.value || val;
      },
      onOpen(opened = false) {
        this.openedSelect = opened;

        if (opened) {
          this.iconName = 'caret-down';
        } else {
          this.iconName = 'caret-down';
        }
      },
    },
  };
</script>

<style scoped lang="scss"></style>
